export function getISTDateWithCurrentTime(dateValue: any): string | null {
  if (!dateValue) return null;

  const dateObj = dateValue instanceof Date ? dateValue : new Date(dateValue);
  if (isNaN(dateObj.getTime())) return null;

  const now = new Date();

  dateObj.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());

  const yyyy = dateObj.getFullYear();
  const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
  const dd = String(dateObj.getDate()).padStart(2, '0');
  const hh = String(dateObj.getHours()).padStart(2, '0');
  const min = String(dateObj.getMinutes()).padStart(2, '0');
  const ss = String(dateObj.getSeconds()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd}T${hh}:${min}:${ss}`;
}

export function getISTDateWithCurrentTime2(dateValue: any): Date | null {
  if (!dateValue) return null;

  const dateObj = dateValue instanceof Date ? dateValue : new Date(dateValue);
  if (isNaN(dateObj.getTime())) return null;

  // Convert UTC time to IST
  const utc = dateObj.getTime() + dateObj.getTimezoneOffset() * 60000; // UTC milliseconds
  const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
  const istTime = new Date(utc + istOffset);

  // Merge current time from local system (hours, minutes, seconds, milliseconds)
  const now = new Date();
  istTime.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());

  return istTime;
}
export function getCurrentISTDate(): Date {
  const now = new Date();
  // Convert to UTC first
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  // IST offset
  const istOffset = 5.5 * 60 * 60 * 1000;
  return new Date(utc + istOffset);
}
export function getISTDateString(): string {
  return new Date().toLocaleString("en-GB", { timeZone: "Asia/Kolkata" }).replace(',', '');
}


export function toISTWithCurrentTime(dateValue: any): Date | null {
  if (!dateValue) return null;

  const date = new Date(dateValue);
  if (isNaN(date.getTime())) return null;

  const now = new Date();

  // apply current time
  date.setHours(
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds()
  );

  return date;
}
export function mergeDateWithSystemTime(dateValue: any): Date | null {
  if (!dateValue) return null;

  const date = new Date(dateValue);
  if (isNaN(date.getTime())) return null;

  const now = new Date();

  date.setHours(
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds()
  );

  return date;
}


export function getISTDateWithCurrentTimeNew(dateValue: any): string | null {
  if (!dateValue) return null;

  const d = new Date(dateValue);
  if (isNaN(d.getTime())) return null;

  const now = new Date();
  d.setHours(
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds()
  );

  const pad = (n: number, z = 2) => ('00' + n).slice(-z);

  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}` +
    `T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}.` +
    `${('000' + d.getMilliseconds()).slice(-3)}`;
}

export function getISTDateWithCurrentTimeIST(dateValue: any): Date | null {
  const now = new Date();

  const dateObj = new Date(dateValue);
  dateObj.setHours(
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds()
  );

  return dateObj;
}

export function getISTDateWithCurrentTime_FORCE_LOCAL(dateValue: any): Date | null {
  if (!dateValue) return null;

  const now = new Date();
  const date = new Date(dateValue);

  date.setHours(
    now.getHours(),
    now.getMinutes(),
    now.getSeconds(),
    now.getMilliseconds()
  );

  const offsetMinutes = date.getTimezoneOffset();
  date.setMinutes(date.getMinutes() - offsetMinutes);

  return date;
}
